export enum Constants {
  SET_PLAYER = '@playerCompare/set_player',
  SET_SIDE_ONE = '@playerCompare/set_side_one',
  SET_SIDE_TWO = '@playerCompare/set_side_two',
  SET_RESULTS = '@playerCompare/set_results',
  SET_AUTH = '@playerCompare/set_auth',
  GET_CONFIG = '@playerCompare/get_config',
}
